<div
    class="text-smallheading pb-4 flex justify-between"
    data-qa="dialog-wrapper_dialog_title"
>
    @if (title) {
        <div>{{ title | translate }}</div>
    } @else {
        <ng-content select="[title]"></ng-content>
    }

    @if (_showCloseButton) {
        <app-button
            data-qa="dialog-wrapper_dialog_close-button"
            icon="close"
            iconButton
            buttonType="ghost"
            (buttonClick)="onCloseClick()"
        ></app-button>
    }
</div>

<div class="text-body-1" data-qa="dialog-wrapper_dialog_body">
    @if (bodyText) {
        <div>{{ bodyText | translate }}</div>
    } @else {
        <ng-content select="[body]"></ng-content>
    }
</div>

@if (!_hideActions) {
    @if (actionButtonText) {
        <app-button-group alignment="right" class="pt-6">
            <app-button
                [buttonType]="cancelButtonType"
                (buttonClick)="onCloseClick()"
                data-qa="dialog-wrapper_dialog_cancel-button"
            >
                @if (cancelButtonText) {
                    {{ cancelButtonText | translate }}
                } @else {
                    <translate>Cancel</translate>
                }
            </app-button>
            <app-button
                [buttonType]="actionButtonType"
                (buttonClick)="onActionButtonClick()"
                data-qa="dialog-wrapper_dialog_action-button"
            >
                <div>
                    {{ actionButtonText | translate }}
                </div>
            </app-button>
        </app-button-group>
    } @else {
        <ng-content select="[actions]"></ng-content>
    }
}
